import classNames from 'classnames';
import React, { FC, PropsWithChildren, useState } from 'react';

import { Icon, IconTypes } from '@eika/icon';

export type AccordionProps = PropsWithChildren<{ tittel: string; key: string }>;
const Accordion: FC<PropsWithChildren<AccordionProps>> = ({ tittel, children, key }) => {
    const [expanded, setExpanded] = useState(false);
    const toggle = () => setExpanded(!expanded);

    const keyToggle = (e: React.KeyboardEvent<HTMLElement>) => {
        if (e.key === 'Enter') toggle();
    };
    return (
        <section key={key} className={classNames('accordion', expanded && 'accordion__expanded')}>
            <header
                onClick={toggle}
                onKeyPress={keyToggle}
                className="accordion__header focus_visible"
                tabIndex={0}
                role="button"
            >
                <strong>{tittel}</strong>
                <Icon type={expanded ? IconTypes.LITEN_PIL_OPP : IconTypes.LITEN_PIL_NED} />
            </header>

            <article className="accordion__article">{children}</article>
        </section>
    );
};

export default Accordion;
